import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Constant } from '@/types';
import { useCreateConstantMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface CreateConstantProps extends DialogProps {
  onClose(): void;
}

const CreateConstant: React.FC<CreateConstantProps> = ({ onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [createConstant, createConstantResponse] = useCreateConstantMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Constant>({
    initialValues: {
      name: '',
      code: '',
      value: '',
    },
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
      code: yup.string().required(messages.form.REQUIRED),
      value: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(constant, { resetForm }) {
      try {
        await createConstant(constant).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Добавить константу</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={createConstantResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="code"
                label="Код"
                placeholder="Введите значение"
                value={values.code}
                onChange={handleChange}
                disabled={createConstantResponse.isLoading}
                error={touched.code && Boolean(errors.code)}
                helperText={touched.code ? errors.code : ''}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="value"
                label="Значение"
                placeholder="Введите значение"
                value={values.value}
                onChange={handleChange}
                disabled={createConstantResponse.isLoading}
                error={touched.value && Boolean(errors.value)}
                helperText={touched.value ? errors.value : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={createConstantResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={createConstantResponse.isLoading}>
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateConstant;
